module.exports = __webpack_public_path__ + "static/img/smoke_x.e9c10e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smoke_x.png
// module id = 07RG
// module chunks = 208